import { useIsMomMode } from '../../hooks/useIsMomMode'
import { useSales } from '../../hooks/useSales'
import { Card, Chip, Skeleton } from '../../components/ui'
import { formatMoney, formatDate } from '../../lib/format'

export default function MomSales() {
  const { consignee, loading: detecting } = useIsMomMode()
  const { data: sales, isLoading } = useSales()

  if (detecting || isLoading) {
    return (
      <div style={{ padding: 'var(--space-4)' }}>
        <Skeleton height={60} style={{ marginBottom: 8 }} />
        <Skeleton height={60} style={{ marginBottom: 8 }} />
      </div>
    )
  }
  if (!consignee) return null

  const mySales = (sales ?? [])
    .filter((s) => s.consignee_id === consignee.id)
    .sort((a, b) => b.created_at.localeCompare(a.created_at))

  return (
    <div style={{ padding: 'var(--space-4)' }}>
      <h1 style={{ marginBottom: 'var(--space-3)' }}>My sales</h1>

      {mySales.length === 0 ? (
        <Card>
          <p style={{ color: 'var(--color-text-muted)', textAlign: 'center', padding: 'var(--space-4)' }}>
            No sales yet.
          </p>
        </Card>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {mySales.map((s) => (
            <li key={s.id} style={{ marginBottom: 'var(--space-2)' }}>
              <Card padding="var(--space-3)">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 'var(--space-2)' }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', gap: 'var(--space-2)', alignItems: 'center', flexWrap: 'wrap' }}>
                      <span style={{ fontWeight: 600 }}>{formatDate(s.sale_date)}</span>
                      {s.is_refunded && <Chip tone="danger">REFUNDED</Chip>}
                      {s.settlement_id && <Chip tone="default">settled</Chip>}
                    </div>
                    {s.moms_cut_at_sale != null && (
                      <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-faint)' }}>
                        Your cut: {formatMoney(Number(s.moms_cut_at_sale))}
                      </div>
                    )}
                  </div>
                  <div style={{ fontWeight: 700, textDecoration: s.is_refunded ? 'line-through' : 'none' }}>
                    {formatMoney(Number(s.gross_amount))}
                  </div>
                </div>
              </Card>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
